import axios from 'axios';
import { msg, openLoding, closeLoding } from './common';

// config設定
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    timeout: process.env.VUE_APP_REQ_TIMEOUT, // request timeout
    withCredentials: true
});

// request interceptor
service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        // do something with request error
        msg("連線失敗", 3000);
        return Promise.reject(error);
    }
);

// Add a response interceptor
service.interceptors.response.use(({ data }) => {
    closeLoding();
    return data;
}, (error) => {
    closeLoding();
    if (error.response.data) msg(error.response.data, 6000);
    return Promise.reject(error);
});

export function dbio(url, data, method = 'get') {
    openLoding();
    if (method === 'get') {
        return service({
            url,
            method,
            params: data
        });
    } else if (method === 'post') {
        return service({
            url,
            method: 'post',
            data
        });
    } else if (method === 'delete'){
        return service({
            url,
            method: 'delete'
        });
    }
    return null;
}
